module.exports = "/images/road_with_stop.png?b6faeddaa160a35315c5fd6ae5ac9ec2";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/banner/road_with_stop.png
// module id = Dwva
// module chunks = 0